import { Link } from "react-router-dom";

const FooterDashboard = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <div className="pt-3 border-t border-[#d9d9d9] mt-5 text-M-text-color text-sm flex gap-2 flex-col sm:flex-row items-center justify-center sm:justify-between">
        <p>Copyright © {currentYear} - All right reserved by <Link to="https://muktihospital.com/" className="font-semibold text-black hover:text-M-primary-color underline transition-all duration-300">Mukti Hospital</Link></p>
        <p>Design & Developed By <Link to="https://microters.com/" className="font-semibold text-black hover:text-M-primary-color underline transition-all duration-300">Microters</Link></p>
      </div>
    </div>
  );
};

export default FooterDashboard;